export function flattenChildren(array) {
    const result = [];

    function traverse(node) {
        result.push(node);
        if (node.children) {
            node.children.forEach(traverse);
        }
    }

    array.forEach(traverse);
    return result;
}

export function getParents(all, selected, res = []) {
    const parentId = selected?.parent;
    if (!parentId) return res;
    res.push(parentId);
    const parent = all.find((item) => item.id === parentId);
    return getParents(all, parent, res);
}
